import './style.css'

import { createHead } from '@unhead/vue/client'
import { createApp } from './app.js'
import RollbarPlugin, { rollbar } from '@/plugins/rollbar.js'
import VueGtag from 'vue-gtag'
import { applySeoHead } from '@/composables/useSeo.js'
import { usePageDataStore } from '@/stores/pageData.js'

const gaId = import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-M2J2TZ9LHD'

const head = createHead()
const { app, router, pinia } = createApp(head)

if (window.__PINIA_STATE__) {
  pinia.state.value = window.__PINIA_STATE__
}

pinia.use(({ store }) => {
  store.$onAction(({ name, onError }) => {
    onError((error) => {
      rollbar.error(error, {
        context: 'store',
        store: store.$id,
        action: name,
      })
    })
  })
})

router.onError((error) => {
  rollbar.error(error, {
    context: 'router',
    route: router.currentRoute.value.fullPath,
  })
})

router.beforeEach((to, from, next) => {
  // Só limpa cache em navegação client-side (preserva dados hidratados do SSR)
  if (from.matched.length > 0) {
    usePageDataStore(pinia).clear()
  }

  if (to.meta?.title) {
    applySeoHead(head, {
      title: to.meta.title.replace(' • Rádio Habblet', ''),
      path: to.fullPath,
    })
  }

  next()
})

app.use(RollbarPlugin)
app.use(VueGtag, {
  enabled: import.meta.env.PROD,
  disableScriptLoad: true,
  config: { id: gaId },
  router,
  pageTrackerExcludedRoutes: ['NotFound', 'Error', 'valores'],
  pageTrackerTemplate(to) {
    return {
      page_title: document.title || to.meta?.title || to.name || 'Rádio Habblet',
      page_path: to.fullPath,
    }
  },
})

router.isReady().then(() => {
  app.mount('#app', true)
})
